import React from 'react';
import ReactApexChart from 'react-apexcharts';

const SalesColumnChart = ({ states }) => {
    if (!states?.first_chart_data) return null;

    // Extract and reverse labels
    const labels = Object.keys(states.first_chart_data);
    const data = labels.map(label => states.first_chart_data[label]);

    const columnChartOptionsTwo = {
        chart: {
            type: 'bar',
            toolbar: { show: false }
        },
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: '50%'
            }
        },
        dataLabels: {
            enabled: false
        },
        xaxis: {
            categories: labels,
            labels: {
                rotate: -45,
                style: {
                    fontSize: '10px'
                }
            }
        },
        yaxis: {
            title: {
                text: 'Value'
            }
        },
        tooltip: {
            y: {
                formatter: val => `${val}`
            }
        }
    };

    const columnChartSeriesTwo = [
        {
            name: 'Value',
            data: data
        }
    ];

    return (
        <ReactApexChart
            id="columnGroupBarChart"
            options={columnChartOptionsTwo}
            series={columnChartSeriesTwo}
            type="bar"
            height={264}
        />
    );
};

export default SalesColumnChart;
